import { ActionConst } from '../../actions/dispositivo/CoDispositivo'

const initialState = {
  dispositivos: [],
  conta: '',
  expressao: '',
  keys: { keys: []} ,
  sort: {
    property: 'id',
    asc: true //Menor para o Maior
  },
  filter_property: [
    'user', 'vm', 'key', 'version', 'platform', 'model', 'registered_at', 'updated_at', 'active'
  ],
  dataSource: [],
  isFetching: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionConst.SET_DISPOSITIVOS:
      return { ...state, dispositivos: action.dispositivos }
    case ActionConst.SET_CONTA:
      return { ...state, conta: action.conta }
    case ActionConst.SET_FILTRO:
      return { ...state, ...action.args }
    case ActionConst.SET_SORT:
      return { ...state, sort: action.sort }
    case ActionConst.SET_DATASOURCE:
      return { ...state, dataSource: action.dataSource }
    case ActionConst.IS_FETCHING:
      return { ...state, isFetching: action.isFetching }
    case ActionConst.TOGGLE_DEVICE:
      return {
        ...state,
        dispositivos: state.dispositivos.map((device) => {
          if (device.id === action.id) {
            return { ...device, active: !device.active }
          } else {
            return device
          }
        })
      }
    case ActionConst.REMOVE:
      return {
        ...state,
        dispositivos: state.dispositivos.filter((device) => (device.id !== action.id))
      }
    case ActionConst.SET_DEVICE_KEYS:
      return {
        ...state, keys: action.keys
      }
    case ActionConst.CLEAN_DEVICE_KEYS: 
      return {
        ...state, keys: { keys:[]}
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dispositivo/CoDispositivo.js